import * as React from 'react'
import Svg, { Path } from 'react-native-svg'

const WavyUnderline = ({
	height = 8,
	width = 104,
}: { height?: number | string; width?: number | string }) => (
	<Svg
		width={width}
		height={height}
		viewBox={'0 0 104 12'}
		fill="none"
		preserveAspectRatio="none"
	>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M101.905 7.26C99.7637 9.37286 97.0975 12 91.8502 12C86.6028 12 83.9346 9.375 81.7928 7.26214C79.6509 5.14929 78.3497 4.00071 75.6114 4.00071C72.8731 4.00071 71.5464 5.17714 69.4343 7.26C67.284 9.37286 64.6179 12 59.3726 12C54.1274 12 51.4528 9.37286 49.311 7.26C47.1692 5.14714 45.87 4.00071 43.1339 4.00071C40.3977 4.00071 39.071 5.17714 36.961 7.26C34.8192 9.37286 32.1573 12 26.9078 12C21.6584 12 18.9901 9.37286 16.8483 7.26C14.7065 5.14714 13.4052 4.00071 10.6691 4.00071C7.93287 4.00071 6.60405 5.17714 4.48983 7.26C2.3756 9.34286 -1.5026 6.83143 0.611623 4.74C2.72585 2.64857 5.41958 0 10.6691 0C15.9185 0 18.5847 2.625 20.7265 4.73786C22.8683 6.85071 24.1695 7.99929 26.9078 7.99929C29.6461 7.99929 30.9686 6.82286 33.0807 4.74C35.1928 2.65714 37.8886 0 43.1339 0C48.3791 0 51.0474 2.62714 53.1913 4.74C55.3034 6.82286 56.6322 7.99929 59.3726 7.99929C62.1131 7.99929 63.4398 6.82286 65.554 4.73786C67.6682 2.65286 70.3577 0 75.6051 0C80.8524 0 83.5228 2.62714 85.6688 4.74C87.7788 6.82286 89.1119 7.99929 91.8438 7.99929C94.5758 7.99929 95.9131 6.82286 98.0273 4.73786C103 1 104.462 4.73786 101.905 7.26Z"
			fill="#76CABB"
		/>
	</Svg>
)
export default WavyUnderline
